import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import ChatWindow from './ChatWindow';

export default function FloatingChatWidget() {
    const [open, setOpen] = useState(false);

    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
            {open && <ChatWindow onClose={() => setOpen(false)} />}
            <button
                onClick={() => setOpen(!open)}
                className="mt-3 w-14 h-14 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition flex items-center justify-center"
                aria-label={open ? 'Chatni yopish' : 'AI Tutorni ochish'}
            >
                <MessageCircle className="w-6 h-6" />
            </button>
        </div>
    );
}
